module.exports = ".modal-dialog.additives-modal {\n    max-width: calc(100% - 100px);\n    width: 70%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/consultants/components/modalAdditive/modalAdditive.component.css
// module id = ./src/app/views/consultants/components/modalAdditive/modalAdditive.component.css
// module chunks = main